module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_WoodMatted_MockedUp.714bb4d2.jpg";